import { createStore } from "vuex";
import { vuexOidcCreateStoreModule } from "vuex-oidc";

import { getOidcSettings } from "../components/Authentication/services/oidcSettings";

const settings = getOidcSettings();

export const authStore = createStore({
  modules: {
    oidcStore: vuexOidcCreateStoreModule(settings, undefined, {
      accessTokenExpired: () => {
        authStore.dispatch("removeOidcUser");
      },
      silentRenewError: () => {
        authStore.dispatch("removeOidcUser");
      },
      oidcError: (payload) => {
        // TODO should always be logged out, if any error happens? #893
        authStore.dispatch("removeOidcUser");
      },
      automaticSilentRenewError: (payload) => {
        authStore.dispatch("removeOidcUser");
      },
    }),
  },
});
